define(
  'app/views/newsletter_footer_view',['app/setup', 'app/views/newsletter_view'],
  function(takhfifan, newsletterView) {

  takhfifan.NewsletterFooterView = takhfifan.NewsletterView.extend({

    events: {
      'click button': 'submit',
      'submit': 'submit',
      'click .dropdown-items li': "changeCity"
    },

    initialize: function(options) {
      this.model.on('newsletter:loading', this.loading, this);
      this.model.on('submit:success', this.success, this);
      this.model.on('submit:invalid', this.renderErrors, this);
      Backbone.Validation.bind(this);
      this.render();
      if(this.$el.hasClass('tags-newsletter')){
        this.newsletterSlideUp();
        this.newsletterSlideDown();
      }
    },

    changeCity: function(e){
      var $target = $(e.target);
      this.$el.find("#newsletterCity").val($target.data("cityId"));
    },
    
    newsletterSlideUp: function() {
      var _this = this;
      if($('.footer-newsletter').length){
        var footerNewsletterBarOffset = $('.footer-newsletter').offset().top;
        var footerHeight = $('.footer').height() + 200;
        if($(window).scrollTop() < (footerNewsletterBarOffset - footerHeight)){
          setTimeout(function() {
            _this.$el.removeClass('hide');
          }, 2000);
        }
      }
    },
    
    newsletterSlideDown: function() {
      var _this = this;
      if($('.footer').length){
        var footerHeight = $('.footer').height() + 200;
        $(window).on('scroll', function() {
          var footerNewsletterBarOffset = $('.footer-newsletter').offset().top;
          if(($(window).width() > 979) && ($(window).scrollTop() > (footerNewsletterBarOffset - footerHeight))){
            _this.$el.addClass('hide');
          }
          else{
            _this.$el.removeClass('hide');
          }
        });
      }
    },

    loading: function() {
      this.$('.icon-warning').remove();
      this.$('button').html('<span class="spinner"></span>');
    },

    success: function() {
      var _this = this;
      this.$('.icon-warning').remove();
      this.$('button').empty().addClass('success').html('<span class="icon-check"></span>');
      setTimeout(function(){
        _this.$('button').removeClass('success').html('اشتراک');
      }, 2500);
      this.$('input[name=email]').val('');
      takhfifan.eventHub.trigger('footernewsletter:subscribe');
    }

  });
});

